export default __webpack_public_path__ + "static/07-2b99a55fa1815606c0c6ee7ccb2f0657.jpg";